import React, { useEffect, useState } from 'react';
import Preloader from '../../Components/Preloader';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { NavLink } from 'react-router-dom';
import Money_Transfer_Seo from '../../SEO/Money_Transfer_Seo';

function MoneyTransfer() {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 500);
    }, []);
    
    return (
        <div>
            {isLoading ? (
                <Preloader />
            ) : (
                <>
                    <Money_Transfer_Seo />
                    <div className='page-wrapper'>
                    <Header />
                    
                    {/* Internal CSS */}
                    <style>
                        {`
                            .header-wrap.style1 .header-top .header-top-left .contact-item a, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a i {
                                color: #fff;
                            }
                                .header-wrap.style1 .header-top .header-top-left .contact-item a:hover, 
                            .header-wrap.style1 .header-top .header-top-right .social-profile li a:hover i {
                                color: #FF414B;
                            }
                        `}
                    </style>
                    
                    {/* Content Wrapper Start */}
                    <div className="content-wrapper">
                        {/* Breadcrumb start */}
                        <div className="breadcrumb-wrap bg-f">
                            <div className="overlay bg-vulcan op-9" />
                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="breadcrumb-title">
                                            <h2>Money Transfer to Nigeria</h2>
                                            <ul className="breadcrumb-menu list-style">
                                                <li><NavLink to="/">Home </NavLink></li>
                                                <li>Money Transfer to Nigeria</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Breadcrumb end */}
                        {/* Money Transfer to Nigeria section start */}
                        <section className="service-wrap pt-100 pb-100">
                            <div className="container">
                                <div className="row">
                                    <div className="col-xl-6">
                                        <div className="service-content">
                                            <div className="content-title style1">
                                                <span>Fast &amp; Easy way to Send Money</span>
                                                <h2>Trustworthy Money Transfer Service</h2>
                                                <p className="mt-20">
                                                    Quick, reliable and trustworthy transfers is what we are know for. With FinestPay you will always get honest answers, no hidden fees and you get what you see. Recipient in Nigeria can collect cash or the Nigerian Naira will be deposited directly to their Bank Account. We have made both payment options available for you, bank transfer, pay by card at one of our branches; choose what best suits you.
                                                </p>
                                            </div>
                                            <div className="service-bg bg-f service-bg-1">
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div className="row ">
                                            <div className="col-lg-6">
                                                <div className="service-card style2">
                                                    <div className="service-info">
                                                        <div className="service-icon">
                                                            <img src="assets/img/icons/safe.png" alt="Safe and Secure" />
                                                        </div>
                                                        <h3 className="service-title">
                                                            <NavLink to="#">Safe and Secure</NavLink>
                                                        </h3>
                                                        <p>
                                                            Our advanced data encryption technology ensures top-notch privacy, ensuring the security of your information.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="service-card style2">
                                                    <div className="service-info">
                                                        <div className="service-icon">
                                                            <img src="assets/img/icons/service.png" alt="24/7 Service" />
                                                        </div>
                                                        <h3 className="service-title">
                                                            <NavLink to="#">
                                                                24/7 Service
                                                            </NavLink>
                                                        </h3>
                                                        <p>
                                                            Our online money transfer service is accessible through our website, dedicated customer support team, and user-friendly mobile app.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="service-card style2">
                                                    <div className="service-info">
                                                        <div className="service-icon">
                                                            <img src="assets/img/icons/payment.png" alt="Worldwide Reach" />
                                                        </div>
                                                        <h3 className="service-title">
                                                            <NavLink to="#">Worldwide Reach</NavLink>
                                                        </h3>
                                                        <p>
                                                            We transfer money from the United Kingdom to over 200 countries and territories.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="service-card style2">
                                                    <div className="service-info">
                                                        <div className="service-icon">
                                                            <img src="assets/img/icons/rate.png" alt="Competitive Rates" />
                                                        </div>
                                                        <h3 className="service-title">
                                                            <NavLink to="#">
                                                                Competitive Rates
                                                            </NavLink>
                                                        </h3>
                                                        <p>
                                                            Our competitive pricing ensures you save more when you choose us over others.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Money Transfer to Nigeria section end */}

                        {/* Steps Section start */}
                        <section className="why-choose-wrap style3 ptb-100 bg-f bg-1">
                            <div className="container">
                                <div className="row gx-5 align-items-center">
                                    <div className="col-lg-6">
                                        <div className="why-choose-content">
                                            <div className="content-title style1 mb-40">
                                                <span>Reliable Money Transfer Service </span>
                                                <h2>Money Transfer at your Fingertips </h2>
                                                <p>
                                                    We recognize that you have worked hard for your money. You deserve a better rate and lower fees, therefore we make every effort to provide you with the greatest rates while keeping expenses to a minimum.
                                                </p>
                                                <ul className="content-feature-list list-style mt-2">
                                                    <li>
                                                        <i className="las la-check-circle" />
                                                        Send money on the go or start a transferand pay in-store.
                                                    </li>
                                                    <li>
                                                        <i className="las la-check-circle" />
                                                        Track your money transfer in real time.
                                                    </li>
                                                    <li>
                                                        <i className="las la-check-circle" />
                                                        Repeat transfers quickly to friends and family.
                                                    </li>
                                                </ul>
                                                <div className="d-flex mt-4">
                                                    <NavLink to="#" target="_blank">
                                                        <img src="assets/img/android.png" />
                                                    </NavLink> &nbsp;
                                                    <NavLink to="#" target="_blank">
                                                        <img src="assets/img/apple.png" />
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="wh-img bg-f wh-bg-5">
                                            <div className="tr-text-wrap">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Steps Section End */}

                        {/* Frequently Asked Questions section start */}
                        <section className="faq-wrap ptb-100">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="content-title style1 mb-40">
                                            <span>FAQ's</span>
                                            <h2>Frequently Asked Questions</h2>
                                        </div>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                                        <span>
                                                            <i className="las la-plus-circle plus" />
                                                            <i className="las la-minus-circle minus" />
                                                        </span>
                                                        Why do you need my documents while registration?
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample" style={{}}>
                                                    <div className="accordion-body">
                                                        <div className="single-product-text">
                                                            <p>
                                                                We are regulated by Financial Conduct Authority in the UK. It is our legal binding to verify your identity as a UK resident.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingTwo">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        <span>
                                                            <i className="las la-plus-circle plus" />
                                                            <i className="las la-minus-circle minus" />
                                                        </span>
                                                        How can I cancel my transfer?
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" className="accordion-collapse collapse " aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>
                                                            Please call us or email us at earliest possible if you want to cancel your transfer. Transfer paid out to the recipient cannot be cancelled. If you have paid for your transfer and the transfer is not processed yet, then please contact us by phone and we will make necessary arrangements for refunds. We may charge you a small fee as handling/service charge and refund you the balance amount.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingThree">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                        <span>
                                                            <i className="las la-plus-circle plus" />
                                                            <i className="las la-minus-circle minus" />
                                                        </span>
                                                        Will I get notifications about Transfer status?
                                                    </button>
                                                </h2>
                                                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>
                                                            Yes. We send email notifications to keep you informed. You can even view the transfer status by signing in into your web account.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingfour">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                                                        <span>
                                                            <i className="las la-plus-circle plus" />
                                                            <i className="las la-minus-circle minus" />
                                                        </span>
                                                        How many recipients I can add?
                                                    </button>
                                                </h2>
                                                <div id="collapsefour" className="accordion-collapse collapse " aria-labelledby="headingfour" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <div className="single-product-text">
                                                            <p>
                                                                There is no restriction on the number of recipients you may have on your account.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-4 text-center">
                                            <NavLink to="/general-faq" className="btn style3">View more FAQ's</NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Frequently Asked Questions section end */}
                    </div>
                    {/* Content Wrapper End */}
                    
                    {/* Footer Section Here */}
                    <Footer />
                    </div>
                </>
            )}
        </div>
    );
}

export default MoneyTransfer;
